import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function BookOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4c-1.938 0-3.7.76-5 2v12.833c0 .44.543.682.906.433A7.217 7.217 0 017 18c1.939 0 3.7.76 5 2 1.301-1.24 3.062-2 5-2 1.52 0 2.93.467 4.095 1.266.363.249.905.007.905-.433V6c-1.3-1.24-3.061-2-5-2-1.938 0-3.699.76-5 2-1.3-1.24-3.062-2-5-2zm13 2.94v9.557A9.238 9.238 0 0017 16c-1.432 0-2.79.326-4 .907V7.85A5.24 5.24 0 0116.966 6h.069A5.225 5.225 0 0120 6.94zM7 16c-1.05 0-2.059.175-3 .497V6.941A5.225 5.225 0 016.966 6h.069c1.588.01 3.01.726 3.965 1.85v9.057A9.212 9.212 0 007 16z"
  }));
}
export default BookOutlineIcon;